
import React from 'react';


//========================================================================================
/*                                                                                      *
 * // this is a functional component                                                    *
 *                                                                                      */
//========================================================================================


function Scontrino(props) {
    const scontrino = props.scontrino;
    return (
        <div key={scontrino.productId} className="scontrino">
            <div> <b>Prodotto:</b> {scontrino.productId} </div>

            <div> <b>Descrizione:</b> {scontrino.description} </div>

            <div> <b>Negozio:</b> {scontrino.codiceNegozio} </div>

            <div> <b>quantita': </b> {scontrino.quantity} </div> <div> <b>Prezzo: </b>  € {scontrino.price}</div>
        </div>

    );
}

export default Scontrino;